//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    url: {
      type: String,
      default: "https://www.youtube.com/embed/cy8zHjW2Kl4",
    },
  },
  mounted() {
    document.getElementsByTagName("body")[0].style.overflowY = "hidden";
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].style.overflowY = "auto";
  },
};
